/**
 *
 * @param {any} value
 * @param {string} type
 * @throws {?TypeError}
 */
var assert = function assert(value, type) {
  var valueType = typeof value;

  if (type === "object") {
    if (Array.isArray(value)) {
      throw new TypeError("Expected \"object\" but \"array\" was received");
    } else if (value === null) {
      throw new TypeError("Expected \"object\" but \"null\" was received");
    } else if (valueType !== type) {
      throw new TypeError("Expected \"".concat(type, "\" but \"").concat(valueType, "\" was received"));
    }
  } else if (type === "array") {
    if (!Array.isArray(value)) {
      throw new TypeError("Expected \"array\" but \"".concat(valueType, "\" was received"));
    }
  } else if (type === "null") {
    if (value !== null) {
      throw new TypeError("Expected \"null\" but \"".concat(valueType, "\" was received"));
    }
  } else if (valueType !== type) {
    throw new TypeError("Expected \"".concat(type, "\" but \"").concat(valueType, "\" was received"));
  }
};

var classNames = function classNames() {
  for (var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++) {
    arr[_key] = arguments[_key];
  }

  return arr.filter(Boolean).join(" ");
};
/* input a number, usually a hash and convert it to base-52 */

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
// Source: https://github.com/garycourt/murmurhash-js/blob/1e3186c42c2dac3738f53a70b0941276a0fdc46a/murmurhash2_gc.js


function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }

  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;

    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;

    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }

  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
} // Source: https://github.com/styled-components/styled-components/blob/0ecbb475fd370a83a91bd42591ebff395de10acd/src/utils/generateAlphabeticName.js

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */


var charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */

var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */


function generateAlphabeticName(code) {
  var name = "";
  var x;
  /* get a char and divide by alphabet-length */

  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

var hashCode = function hashCode(str) {
  return generateAlphabeticName(murmurhash(str));
};
/**
 * @param {string} hash
 * @param {HTMLElement} target
 * @param {IScrollToOptions} [options={}]
 * @return {void}
 */


var scrollTo = function scrollTo(hash, target) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!options.noHash) {
    window.location.hash = hash;
  }

  var el = document.getElementById(hash);

  if (!options.noFocus) {
    target.focus();
  } // Attempted to implement smooth scrolling if the page changes by one position.
  // The page jumps in several state changes
  // @todo Fix unless a browser bug exists.
  // const index = parseInt(hash.split("/").reverse()[0], 10) - 1;
  // const diff = Math.abs(index - page);
  // document.documentElement.style["scroll-behavior"] = diff > 1 ? "auto" : "smooth";


  el.scrollIntoView(true); // Optionally if Element.scrollIntoView does not return the expected result.
  // const {top: tEl} = el.getBoundingClientRect();
  // const {top: tBody} = document.body.getBoundingClientRect();
  // const offset = tEl - tBody;
  // window.scrollTo(0, offset);
};

var throttle = function throttle(callback, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var context, args, result;
  var timeout = null;
  var previous = 0;

  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = callback.apply(context, args);

    if (!timeout) {
      context = args = null;
    }
  };

  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      previous = now;
      result = callback.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }

    return result;
  };
};

export { assert, classNames, hashCode, scrollTo, throttle };